// extracted by mini-css-extract-plugin
export var tool = "tool-module--tool--OB3vz";
export var tool__img_wrapper = "tool-module--tool__img_wrapper--iNzgy";
export var tool__btn = "tool-module--tool__btn--3z4If";